// const baseServerUrl = "http://47.243.186.165";
const baseServerUrl = "http://admin.sinpro.ai";
export { baseServerUrl };
